import { store } from "..";
import { LOGOUT } from "../store/types";
// import { getAllVectorStoreIds, clearTrackedVectorStores } from "../services/vector-store-tracking.service";
// import vectorStoreCleanupService from "../services/vector-store-cleanup.service";
import { clearAllTutorialData } from "./tutorial-storage";
import { removeAllActiveFacilities } from "../store/reducers/activeFacilities.slice";
import { setSelectedAccount } from "../store/reducers/common.slice";
import logger from "./logger";
import api from "../services/api/api";

export async function signOut(navigate, onBeforeLogout) {
  if (typeof onBeforeLogout === "function") {
    await onBeforeLogout();
  }

  try {
    await api.post('/api/user/logout');
  } catch (error) {
    // Don't block logout if API call fails - continue with local cleanup
  }

  // Vector store cleanup on logout — disabled (new agent API does not use vector stores)
  /*
  try {
    const vectorStoreIds = getAllVectorStoreIds();
    if (vectorStoreIds.length > 0) {
      logger.log(`🧹 Cleaning up ${vectorStoreIds.length} vector stores before logout...`);
      try {
        await vectorStoreCleanupService.deleteVectorStores(vectorStoreIds);
        logger.log('✅ Vector stores cleaned up successfully');
      } catch (error) {
        // Don't block logout if cleanup fails
        logger.error('⚠️ Failed to cleanup vector stores (continuing logout):', error);
      }
    }
    // Clear tracking regardless of cleanup result
    clearTrackedVectorStores();
  } catch (error) {
    // Don't block logout if tracking cleanup fails
    logger.error('⚠️ Error during vector store cleanup (continuing logout):', error);
  }
  */
  // Clear Redux state FIRST (tab-specific) to prevent any side effects
  // This ensures Redux state is cleared before localStorage, preventing repopulation
  store.dispatch(removeAllActiveFacilities());
  store.dispatch(setSelectedAccount(null));
  store.dispatch({ type: LOGOUT, payload: null });
  
  // Clear localStorage to remove persistent data
  localStorage.removeItem("x-auth");
  localStorage.removeItem("facilityId");
  localStorage.removeItem("accountId");

  // Clear sessionStorage values
  sessionStorage.removeItem("facilityId");
  sessionStorage.removeItem("accountId");
  
  // Clear tutorial data before clearing all localStorage
  clearAllTutorialData();

  // Preserve lastLoginEmail
  const lastLoginEmail = localStorage.getItem("lastLoginEmail");

  // Clear all localStorage items as final cleanup
  window.localStorage.clear();

  // Restore lastLoginEmail
  if (lastLoginEmail) {
    localStorage.setItem("lastLoginEmail", lastLoginEmail);
  }

  // Clear sessionStorage as well (API uses sessionStorage for auth token)
  sessionStorage.removeItem("x-auth");
  
  // Verify state is cleared (for debugging)
  const stateAfterClear = store.getState();
  logger.debug("State after logout clear:", {
    facilities: stateAfterClear.activeFacilities?.facilities,
    selectedAccount: stateAfterClear.common?.selectedAccount,
    auth: stateAfterClear.auth
  });
  
  await navigate("/login", { replace: true });
  await navigate(0);
}
